import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MessageMaster } from "@app/shared/messagemaster/messagemaster.component";
import { HubUser } from "@appcore/models";
import { AuthenticationService, AuthorizationService, CookieService } from "@appcore/service";
import { BehaviorSubject, Observable } from "rxjs";

@Component({
	selector: "app-home",
	templateUrl: "./home.component.html"
})
export class HomeComponent implements OnInit {
	sysAdminAccess: Observable<boolean>;
	adminAccess: Observable<boolean>;

	products: Observable<boolean>;
	productLines: Observable<boolean>;
	assessments: Observable<boolean>;
	insights: Observable<boolean>;
	courseCustomizer: Observable<boolean>;
	productExporter: Observable<boolean>;

	clientView: boolean;
	loading: boolean;
	adminRoleLevel: string;
	userRoles: string;
	hideMOTD = false;
	motdCookie = "";
	sysMsgs = [];
	isAuthenticated: BehaviorSubject<boolean>;
	hasAdminRole = false;

	adminAccessResolved = false;
	sysAdminAccessResolved = false;

	currentUser: HubUser;
	messageKey = "home";

	@ViewChild("intropop", { static: true }) intropop: { visible: boolean };

	Status: any = {
		Header: "Progress Status",
		Message: "Loading profile..."
	};

	constructor(
		private cookieService: CookieService,
		private authenticationService: AuthenticationService,
		private authorizationService: AuthorizationService,
		private router: Router,
		private messageMaster: MessageMaster
	) {}

	ngOnInit(): void {
		this.authenticationService.getCurrentUserValue().subscribe(currentUser => {
			this.isAuthenticated = this.authenticationService.$authed;

			if (this.authenticationService.$authed.value === true && currentUser !== undefined) {
				this.setContentAccess(currentUser.ID);
			}

			if (this.authenticationService.$authed.value === false && currentUser === undefined) {
				console.log("Redirecting to login.");
				this.router.navigate(["login"]);
			}

			//this.messageOfTheDay(); //RETAIN for when we have a MOTD to display
		});
	}

	/**
	 * Sets the page content access based on authenticated associated user role groups.
	 *
	 * @param id - the id of the user
	 */
	private setContentAccess(id: string) {
		Promise.all([
			(this.adminAccess = this.authorizationService.validateGroup(id, "PLS-Admin")),
			(this.sysAdminAccess = this.authorizationService.validateGroup(id, "System-Administrator")),
			(this.products = this.authorizationService.validatePermission(id, "Products")),
			(this.productLines = this.authorizationService.validatePermission(id, "Product Lines")),
			(this.assessments = this.authorizationService.validatePermission(id, "Assessments")),
			(this.insights = this.authorizationService.validatePermission(id, "Insights")),
			(this.courseCustomizer = this.authorizationService.validatePermission(id, "Course Customizer")),
			(this.productExporter = this.authorizationService.validatePermission(id, "Admin Product Exporter"))
		])
			.then(() => {
				if (this.adminAccess) {
					this.clientView = false;
				} else {
					this.clientView = true;
				}
				this.adminAccess.subscribe(() => {
					this.adminAccessResolved = true;
					this.sysAdminAccess.subscribe(() => {
						this.sysAdminAccessResolved = true;
						this.loading = !(this.adminAccessResolved && this.sysAdminAccessResolved);
					});
				});
			})
			.catch(() => {
				console.error("Content Access Failed");
			});
	}


	/**
	 * Displays the message of the day.
	 * Note: Retain for when we have a MOTD to display.
	 */
	private messageOfTheDay(): void
	{
		// this.cookieService.deleteCookie("motdCookie")
		// setTimeout(() => { this.intropop.visible = !this.hideMOTD; }, 250);
		this.hideMOTD = this.cookieService.getCookie('motdCookie') == "welcome";
		this.intropop.visible = !this.hideMOTD;
		if (!this.hideMOTD) {
			this.messageMaster.uniqueMessage(this.messageKey, {
				severity: "warn",
				summary: "PLS HUB Beta",
				detail: "The HUB is a multifunction web application portal for staff and client use. Priviledged users can: view analytical data, generate reports, manage products lines, edit courses and monitor system components & resources."
			});
			this.cookieService.setCookie("motdCookie", "welcome", 1);
		}
	}

	onMOTDCheckChange(val: { toString: () => string }): void {
		this.cookieService.setCookie("motdCookie", val.toString(), 7);
	}
}
